import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

export function LegacyRedirect({ build }) {
  const params = useParams();
  const location = useLocation();
  const target = build(params, location);

  return <Navigate to={`${target}${location.search || ""}`} replace />;
}

export default LegacyRedirect;
